import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { showModal, logIn, showSpinner } from "../../Slices/sessionSlice";
import {
  Modal,
  InputGroup,
  FormControl,
  Card,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import "./LoginModal.css";
import "bootstrap/dist/css/bootstrap.css";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import SpinnerButton from "../SpinnerButton/SpinnerButton";

//#region CONSTANTS
export const id = "Login";
const loginButtonId = "loginButton";
//#endregion

function LogInModal() {
  const [state, setState] = useState({
    email: "",
    password: "",
  });

  const dispatch = useDispatch();
  // let history = useHistory();

  const onHide = () => {
    dispatch(showModal(null));
    dispatch(showSpinner(null));
  };

  const { email, password } = state;

  return (
    <Modal show={true} onHide={onHide}>
      <Modal.Header className="justify-content-center">
        <h3>Log In</h3>
      </Modal.Header>
      <Modal.Body>
        <Container fluid>
          <Card style={{ width: "28rem" }}>
            <Card.Body>
              <Row>
                <InputGroup size="lg" className="mb-3">
                  <FormControl
                    value={email}
                    name="email"
                    placeholder="username"
                    onChange={_handleInputChange}
                    aria-label="Large"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </InputGroup>
              </Row>
              <Row>
                <InputGroup size="lg" className="mb-3">
                  <FormControl
                    value={password}
                    name="password"
                    placeholder="Password"
                    onChange={_handleInputChange}
                    type="password"
                    aria-label="Large"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </InputGroup>
              </Row>
              <Row>
                <Col></Col>
                <Col>
                  <SpinnerButton
                    variant={"outline-success"}
                    onClick={_handleSubmit}
                    name={"Log In"}
                    id={loginButtonId}
                    buttonClassnames="w-100"
                  />
                </Col>
                <Col></Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </Modal.Body>
    </Modal>
  );

  function _handleSubmit(event) {
    event.preventDefault();
    dispatch(logIn({ email, password }));
    dispatch(showSpinner({ id: loginButtonId }));
  }

  function _handleInputChange(event) {
    const value = event.target.value;
    setState({
      ...state,
      [event.target.name]: value,
    });
  }

  // function _handleSignUp() {
  //   dispatch(showModal({ id: SignUpModalId, data: null }));
  // }

  // function showGoogleLoginError() {
  //   if (window.location.search === "?error=facebook_login_failed") {
  //     return (
  //       <div style={{ color: "red", textAlign: "center" }}>Failed to login</div>
  //     );
  //   }
  // }
}

export default LogInModal;
